<div
  id="content-component"
  [ngStyle]="{ 'overflow-y': overflow, height: height, maxHeight: maxHeight, minHeight: minHeight }">
  <ng-content></ng-content>
</div>
